import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Combina y resuelve conflictos de clases Tailwind.
 * Usar siempre que se compongan className condicionales.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
